import { useAlertas } from '../../context/AlertasContext';
import React, { useEffect } from 'react'

//Services
import { showMessage } from '../../services/message';
import { getSessionCookie } from '../../services/session'

export default function Home() {
  const session = getSessionCookie();
  const { permissaoExibirAlertasUsuario } = useAlertas();

  async function handlepermissaoExibirAlertasUsuario() {
    try {
      await permissaoExibirAlertasUsuario();
    } catch (error) {
      showMessage("Error", error?.message ?? "Error na operação", "error", null)
    }
  }

  useEffect(() => {
    if (!!session) {
      setTimeout(() => {
        handlepermissaoExibirAlertasUsuario()
      }, 500)
    }
  }, [session]);


  return <div className="header bg-gradient-info pb-8 pt-5 pt-md-7 no-print"></div>
}
